import Tools from './../components/tools';

export default class Tarifs {
    constructor() {
        // Tarifs

        this.accordeon();
    }

    accordeon() {
        const btns = document.querySelectorAll('.tarifs__prix--accordeon');

        if (btns.length > 0) {
            btns.forEach((btn) => {
                btn.addEventListener('click', (e) => {
                    e.preventDefault();

                    btn.nextElementSibling.classList.toggle('js-open');
                    btn.classList.toggle('js-open');

                    if (btn.nextElementSibling.classList.contains('js-open')) {
                        // Si ouvrir l'accordeon

                        Tools.fixedToAuto(btn.nextElementSibling);
                        setTimeout(() => {
                            btn.nextElementSibling.classList.add('js-visible');
                        }, 500);
                    } else {
                        // Else fermer l'accordeon

                        Tools.autoToFixed(btn.nextElementSibling);
                        btn.nextElementSibling.classList.remove('js-visible');
                    }
                });
            });
        }
    }
}